import src from "IMAGE";
export default { src, width: 360, height: 202, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAM0lEQVR42n2MOwoAMAxCc//T5jPoZmmmQkqGByryjKQ27C2Z2YwDAFWV3F0R0fluw/DjABdQfGxTKOlYAAAAAElFTkSuQmCC"};
